// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/action/universal-io/app/universal-table2/universal-table.component.css
// module id = 690
// module chunks = 0